import { PLACEHOLDER_SOLID_SLAB_STYLE_ID } from '../../types/doorConfiguration';
import { getProductColour } from '../../colour/productColours';
import { normaliseHex } from '../../colour/productColour';

export const EXTERNAL_SLAB_STYLE_PLACEHOLDER_SOLID = PLACEHOLDER_SOLID_SLAB_STYLE_ID;

/** Safe fill when the colour identifier is not a catalogue id or a hex CSS colour. */
export const EXTERNAL_SLAB_FALLBACK_FILL = '#ececec';

/**
 * Catalogue colour ids resolve to their HEX. Raw hex CSS colours are accepted.
 * Anything else, including RAL text, uses the safe fallback.
 */
export function resolveExternalSlabFill(colourId: string): string {
  const catalogue = getProductColour(colourId.trim());
  if (catalogue) return catalogue.hex;
  return normaliseHex(colourId) ?? EXTERNAL_SLAB_FALLBACK_FILL;
}
